const INACTIVITY_LIMIT_MS = 30 * 60 * 1000; // 30 minutos

export const clearSessionStorage = () => {
  localStorage.removeItem('user');
  localStorage.removeItem('token');
  localStorage.removeItem('lastActivityAt');
};

export const touchSessionActivity = () => {
  localStorage.setItem('lastActivityAt', String(Date.now()));
};

export const isSessionValidLocally = () => {
  try {
    const token = localStorage.getItem('token');
    const userRaw = localStorage.getItem('user');

    if (!token || !userRaw || token === 'null' || token === 'undefined') {
      clearSessionStorage();
      return false;
    }

    // Comprobar expiración por inactividad persistida (incluso si se cerró el navegador)
    const lastActivity = Number(localStorage.getItem('lastActivityAt') || 0);
    if (lastActivity > 0 && Date.now() - lastActivity > INACTIVITY_LIMIT_MS) {
      clearSessionStorage();
      return false;
    }

    // Validar estructura y expiración criptográfica del JWT
    const parts = token.split('.');
    if (parts.length !== 3) {
      clearSessionStorage();
      return false;
    }

    const base64Url = parts[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const payload = JSON.parse(window.atob(base64));

    // Rechazar tokens temporales de 2FA o tokens expirados
    if (payload.scope === 'mfa_pending') {
      clearSessionStorage();
      return false;
    }
    if (payload.exp && payload.exp * 1000 <= Date.now()) {
      clearSessionStorage();
      return false;
    }

    const user = JSON.parse(userRaw);
    if (!user || !user.id || !user.email) {
      clearSessionStorage();
      return false;
    }

    return true;
  } catch (e) {
    clearSessionStorage();
    return false;
  }
};

export const getAuthorizedHeaders = () => {
  const token = localStorage.getItem('token');
  return {
    "Content-Type": "application/json",
    ...(token ? { "Authorization": `Bearer ${token}` } : {}),
  };
};
